module.exports = __webpack_public_path__ + "static/media/text_ breakthrough.10f9b20f.png";